// extracted by mini-css-extract-plugin
export default {"mainCont":"ActiveSimJob_mainCont__oTqbS"};